export class PleaseUploadARecentPhotoOfYourselfEntityModel {
  File: string;
}
